import { Button } from "@monsterindia/global-ui-components";
import React from "react";

type ActionButtonContainerProps = {
  primaryBtnLabel: string;
  primaryBtnOnClick?: () => void;
  secondaryBtnLabel?: string;
  secondaryBtnOnClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  isAutoApplyCTA?: boolean;
};

export const ActionButtonContainer = ({
  primaryBtnLabel,
  primaryBtnOnClick,
  secondaryBtnLabel,
  secondaryBtnOnClick,
  isLoading,
  disabled = false,
  isAutoApplyCTA = false,
}: ActionButtonContainerProps) => {
  return (
    <div
      className="l1-fixed l1-bottom-0 l1-left-0 l1-z-10 l1-flex l1-w-full l1-max-w-full l1-gap-2 l1-bg-white l1-px-4 l1-py-3 l1-shadow-black-sm md:!l1-px-8 md:l1-py-4"
      id="l1ActionBtnContainer"
    >
      {secondaryBtnLabel ? (
        <Button
          type="button"
          modifier="tertiary"
          label={secondaryBtnLabel}
          onClick={secondaryBtnOnClick}
          className="!l1-w-full"
          disabled={disabled}
        />
      ) : null}
      <Button
        type="submit"
        modifier="primary"
        isLoading={isLoading}
        label={primaryBtnLabel}
        onClick={primaryBtnOnClick}
        className={`!l1-ml-auto !l1-w-full !l1-max-w-full ${!secondaryBtnLabel ? `${isAutoApplyCTA ? "md:!l1-w-auto" : "md:!l1-max-w-36"}` : ""}`}
      />
    </div>
  );
};
